import { render, staticRenderFns } from "./UserAccountControls.vue?vue&type=template&id=38317a84&"
import script from "./UserAccountControls.vue?vue&type=script&lang=js&"
export * from "./UserAccountControls.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountControls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports